var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 21H28L10 39L28 57H67V21ZM34 43.5C36.4852 43.5 38.5 41.4852 38.5 39C38.5 36.5148 36.4852 34.5 34 34.5C31.5148 34.5 29.5 36.5148 29.5 39C29.5 41.4852 31.5148 43.5 34 43.5Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57V21H26L8 39L26 57H65Z",
    stroke: "#221C35",
    strokeOpacity: 0.3,
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40 39C40 42.3138 37.3138 45 34 45C30.6863 45 28 42.3138 28 39C28 35.6862 30.6863 33 34 33C37.3138 33 40 35.6862 40 39Z",
    stroke: "black",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSubscription);
export default __webpack_public_path__ + "static/media/active_subscription.517a651a6298296ce06805a7c485909d.svg";
export { ForwardRef as ReactComponent };